import { atom } from 'jotai';

// Grid row shape for the waiver list. Dates are parsed to Date objects so the
// grid's date column filters/sorters work client-side.
export type WaiverGridRow = {
  id: string;
  clientName: string;
  clientNumber: string;
  matterNumber: string;
  adverseClientName: string;
  adverseContactSigner: string;
  adverseLetterDate: Date | null;
  adverseAttorney: string;
  clientContact: string;
  clientLetterDate: Date | null;
  clientAttorney: string;
  multipleWaivers: string;
};

// Data atoms for the waiver list. These persist across navigation so returning
// to the dashboard (e.g. back from a waiver detail page) does not re-fetch.
export const waiverRecordsAtom = atom<WaiverGridRow[]>([]);
export const isLoadingWaiversAtom = atom<boolean>(false);
export const waiversErrorAtom = atom<Error | null>(null);

// Incremented to trigger a full reload of the waiver list.
export const reloadWaiversAtom = atom<number>(0);

// Tracks the reloadWaivers token that produced the currently loaded data, so the
// loader can skip re-fetching when the dashboard re-mounts. Null until the first
// load completes.
export const loadedWaiversTokenAtom = atom<number | null>(null);
